import { $win, $doc, $body } from "../utils/globals";
import classNames from "../utils/constant-names";
import { isMobile } from '../utils/is-mobile';
import { isIe } from '../utils/is-ms';

const headerBar = ($('.header .header__bar').length) ? $('.header .header__bar').innerHeight() : 0;

$doc.on( 'ready', () => {
	$body.addClass( isMobile ? classNames.IsTouch : classNames.NoTouch )
	$body.addClass( isIe() ? classNames.IsIE : '' )
})

$win.on( 'load', () => $body.addClass( classNames.PageLoaded ) );

$win.on('scroll load orientationchange', () => {
	$body.toggleClass(classNames.IsScrolled, $win.scrollTop() > headerBar);
});
